<h2 mat-dialog-title>{{ 'searchJurisdictions.searchJurisdictions' | transloco }}</h2>
<mat-dialog-content>
  <table mat-table [dataSource]="jurisdictions" class="mat-elevation-z8">
    <!-- Jurisdiction Column -->
    <ng-container matColumnDef="jurisdiction">
      <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.jurisdiction' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.jurisdiction}} </td>
    </ng-container>

    <!-- HitDirect Column -->
    <ng-container matColumnDef="hitDirect">
      <th mat-header-cell *matHeaderCellDef> HitDirect </th>
      <td mat-cell *matCellDef="let element"> 
        <mat-checkbox [(ngModel)]="element.hitDirect" disabled="true"></mat-checkbox> 
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.status' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{getStatusFromState(element.searchJurisdictionStateID)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>